// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"8e4ca972","735":"4398730d","964":"57afcad5"}[chunkId] + ".chunk.css";
};